// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const nn: CountryValidator<"BE"> = createValidator(
  "be.nn",
  19,
);

export default nn;
export const compact = nn.compact;
export const format = nn.format;
export const validate = nn.validate;
export const generate = (): string =>
  nn.generate?.() ??
  (() => {
    throw new Error(
      "Validator be.nn cannot generate values",
    );
  })();
export const checksum = (value: string): number | null =>
  getBinding().beNnChecksum(value);
